// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jMHw","colMin":"styles_colMin__2J_HE"};